



























import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import Requester from '../../requester';

import { GruposResultadosExamesForm } from '../../../../back/src/types';

import ResultadosDeExamesGrupoItemForm from './ResultadosDeExamesGrupoItemForm.vue';

export default Vue.extend({
  name: 'ResultadosDeExamesGrupoForm',
  components: {
    ResultadosDeExamesGrupoItemForm,
  },
  props: {
    grupoResultados: {
      type: Object as () => GruposResultadosExamesForm,
      required: true,
    },
    filterExame: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
    };
  },
  computed: {
    buscaVazia(): boolean {
      if (this.filterExame) {
        return !this.show(this.grupoResultados.nomesExamesConcat, this.filterExame);
      }
      return false;
    },
  },
  methods: {
    show(haystack: string, needle: string) {
      const haystackDeburr = _.deburr(_.lowerCase(haystack));
      const needleDeburr = _.deburr(_.lowerCase(needle));
      return haystackDeburr.includes(needleDeburr);
    },
  },
});
